import * as actionTypes from "../actionTypes";

const initialState = {
  search: "",
  startDate: "",
  endDate: "",
  perPage: 10,
  page: 0,
};

export const historyReducer = (state = initialState, action) => {
  let ret = "";
  switch (action.type) {
    case actionTypes.SEARCH_SEARCH_BAR:
      ret = "search";
      break;

    case actionTypes.SEARCH_START_DATE:
      ret = "startDate";
      break;
    case actionTypes.SEARCH_PERPAGE:
      ret = "perPage";
      break;
    case actionTypes.SEARCH_PAGE:
      ret = "page";
      break;
    case actionTypes.SEARCH_END_DATE:
      ret = "endDate";
      break;

    default:
      return state;
  }
  return { ...state, [ret]: action.payload };
};
